import {MediaCardType} from '@wandb/weave/common/types/media';
import React, {useMemo} from 'react';

import {useRampFlagSemanticLegend} from '../../../util/rampFeatureFlags';
import {SUPPORTED_MEDIA_TYPES} from '../../PanelMediaBrowser/useGetIsMediaPanelSettingsDrawerSupportedForPanel';
import {
  WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION,
  WORKSPACE_MEDIA_SETTINGS_DESCRIPTION,
  WORKSPACE_SEMANTIC_LEGENDS_SETTINGS_DESCRIPTION,
} from './constants';
import {SettingsDrawerWrapper} from './SettingsDrawerWrapper';
import {SettingsMenuItem} from './SettingsMenuItem';
import {SelectedSettingType} from './types';
import {useWorkspaceSettingsContext} from './WorkspaceSettingsContextProvider';

export const SettingsMenu = ({
  entityName,
  setSelectedSettingType,
  isSingleRun,
}: {
  entityName: string;
  setSelectedSettingType: (type: SelectedSettingType | undefined) => void;
  isSingleRun: boolean;
}) => {
  const {
    media: {mediaCardTypes},
  } = useWorkspaceSettingsContext();
  const shouldShowMediaSettings = useMemo(() => {
    return mediaCardTypes.some((cardType: MediaCardType) =>
      SUPPORTED_MEDIA_TYPES.includes(cardType)
    );
  }, [mediaCardTypes]);
  return (
    <SettingsDrawerWrapper title="Workspace settings">
      <SettingsMenuItem
        dataTest="workspace-layout-menu-item"
        icon="layout-grid"
        color="cactus"
        title="Workspace layout"
        description="Define the overall structure of this workspace, including sectioning logic and panel organization."
        onClick={() => setSelectedSettingType('workspace-layout')}
      />
      {useRampFlagSemanticLegend(entityName) && !isSingleRun && (
        <SettingsMenuItem
          dataTest="workspace-semantic-legend-menu-item"
          icon="running-repeat"
          color="green"
          title="Runs"
          description={WORKSPACE_SEMANTIC_LEGENDS_SETTINGS_DESCRIPTION}
          onClick={() => setSelectedSettingType('semantic-legend')}
        />
      )}
      <SettingsMenuItem
        dataTest="workspace-line-plot-menu-item"
        icon="line-plot-alt2"
        color="blue"
        title="Line plots"
        description={WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION}
        onClick={() => setSelectedSettingType('line-plot')}
      />
      {shouldShowMediaSettings && (
        <SettingsMenuItem
          dataTest="workspace-media-menu-item"
          icon="photo"
          color="purple"
          title="Media settings"
          description={WORKSPACE_MEDIA_SETTINGS_DESCRIPTION}
          onClick={() => setSelectedSettingType('media')}
        />
      )}
    </SettingsDrawerWrapper>
  );
};
